import {RootState} from "../index";
import BlogService, {IBlogCreateEdit} from "../../api/blogService";
import {toastError, toastSuccess} from "../../component/shared/toast/Toast";
import i18n from "../../config/i18n";
import {getSafeBackendErrorMessage} from "../../util/utils";
import {setApplicationError} from "../app/Slice";
import {createAsyncThunk} from "@reduxjs/toolkit";
import {SliceNames} from "../constants";

export const getBlogs =
    createAsyncThunk(`${SliceNames.BLOG}/getBlogs`,
        async (req: { page: number, loadMore: boolean, sorting: string }, thunkAPI) => {
            try {
                const sortingParts = req.sorting.split(',')
                const res = await BlogService.fetchBlogs(req.page, 10, sortingParts[0], sortingParts[1])
                const oldBlogs = (thunkAPI.getState() as RootState).blogReducer.items.data
                res.data.data = !req.loadMore ? res.data.data : [...oldBlogs, ...res.data.data]

                return res.data
            } catch (e: any) {
                return thunkAPI.rejectWithValue(e)
            }
        })

export const getBlogById =
    createAsyncThunk(`${SliceNames.BLOG}/getBlogById`,
        async (blogId: string, thunkAPI) => {
            try {
                const res = await BlogService.fetchBlogById(blogId)
                return res.data
            } catch (e: any) {
                thunkAPI.dispatch(setApplicationError({
                    isError: true,
                    statusCode: e.response?.status
                }))
                return thunkAPI.rejectWithValue(e)
            }
        })

export const deleteBlog =
    createAsyncThunk(`${SliceNames.BLOG}/deleteBlog`,
        async (req: { blogId: string, handleCloseDialog: () => void }, thunkAPI) => {
            try {
                await BlogService.deleteBlog(req.blogId)
                req.handleCloseDialog()
                toastSuccess(i18n.t('changes_saved_success'))
                return req.blogId
            } catch (e: any) {
                toastError(getSafeBackendErrorMessage(e.response?.data?.detail))
                return thunkAPI.rejectWithValue(e)
            }
        })

export const createBlog =
    createAsyncThunk(`${SliceNames.BLOG}/createBlog`,
        async (req: { blog: IBlogCreateEdit, handleCloseDialog: () => void }, thunkAPI) => {
            try {
                const res = await BlogService.createBlog(req.blog)
                req.handleCloseDialog()
                toastSuccess(i18n.t('changes_saved_success'))
                return res.data
            } catch (e: any) {
                toastError(getSafeBackendErrorMessage(e.response?.data?.detail))
                return thunkAPI.rejectWithValue(e)
            }
        })


export const updateBlog =
    createAsyncThunk(`${SliceNames.BLOG}/updateBlog`,
        async (req: { blogId: string, blog: IBlogCreateEdit, handleCloseDialog: () => void }, thunkAPI) => {
            try {
                const res = await BlogService.updateBlog(req.blogId, req.blog)
                req.handleCloseDialog()
                toastSuccess(i18n.t('changes_saved_success'))
                return res.data
            } catch (e: any) {
                toastError(getSafeBackendErrorMessage(e.response?.data?.detail))
                return thunkAPI.rejectWithValue(e)
            }
        })
